/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import { gql } from 'urql';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** Step = step challenge, Spend = spend challenge */
export type ChallengeProgressType = 'Spend' | 'Step';

/** NOT_STARTED = Customer is qualified for challenge, STARTED = Customer has opted in, IN_PROGRESS: challenge is in progress, COMPLETED: customer has completed the challenge */
export type ChallengeStatus = 'COMPLETED' | 'IN_PROGRESS' | 'NOT_STARTED' | 'STARTED';

export type ChallengeThemeV2 = 'DEFAULT' | 'FLASH' | 'HURDLE' | 'UNLIMITED';

/** InStore = Reward can be redeemed in store, Delivery = Reward can be redeemed in delivery, Pickup = Reward can be redeemed in pickup, All = Reward can be redeemed in all channels */
export type RedemptionChannel = 'All' | 'Delivery' | 'InStore' | 'Kiosk' | 'Outpost' | 'Pickup';

/** PREMIUM = Reward is part of loyalty program, NON_PREMIUM = Reward is outcome of challenge/other outlet but not loyalty program */
export type RewardType = 'NON_PREMIUM' | 'PREMIUM';

export type TierName =
  | 'OPTED_OUT'
  | 'REWARDS_BASE'
  | 'REWARDS_OPTED_OUT'
  | 'SWEETPASS'
  | 'SWEETPASS_PLUS';

export type LoyaltyInfoQueryVariables = Exact<{ [key: string]: never }>;

export type LoyaltyInfoQuery = {
  readonly currentCustomer: {
    readonly __typename: 'Customer';
    readonly id: string;
    readonly firstName: string | null;
  } | null;
  readonly loyaltyProfile: {
    readonly customerId: string;
    readonly points: {
      readonly total: number;
      readonly available: number;
      readonly pending: number;
    } | null;
    readonly rewards: ReadonlyArray<{
      readonly __typename: 'Reward';
      readonly id: string;
      readonly name: string;
      readonly expirationDate: string | null;
      readonly rewardType: Types.RewardType;
      readonly redeemable: boolean;
      readonly isFeatured: boolean;
      readonly redeemableAt: string | null;
      readonly redemptionChannel: Types.RedemptionChannel;
      readonly terms: string;
      readonly assetUrl: string | null;
    }> | null;
    readonly pointsRewards: ReadonlyArray<{
      readonly __typename: 'PointsReward';
      readonly id: string;
      readonly points: number;
      readonly redeemable: boolean;
      readonly assetUrl: string | null;
      readonly name: string;
    }> | null;
    readonly tier: {
      readonly __typename: 'Tier';
      readonly id: string;
      readonly nameV2: Types.TierName;
    } | null;
  } | null;
  readonly challenges: ReadonlyArray<{
    readonly __typename: 'Challenge';
    readonly achieved: number;
    readonly celebrationCopy: string;
    readonly descriptiveTitle: string;
    readonly expirationDate: string | null;
    readonly goal: number;
    readonly id: string;
    readonly legalTerms: string;
    readonly percentageCompleted: number;
    readonly permalink: string;
    readonly progressType: Types.ChallengeProgressType;
    readonly progress: number;
    readonly progressCopy: string;
    readonly status: Types.ChallengeStatus;
    readonly title: string;
    readonly themeV2: Types.ChallengeThemeV2;
    readonly assetUrl: string | null;
    readonly multipleBehaviorDetails: {
      readonly hurdleBehaviors: ReadonlyArray<{
        readonly goal: number;
        readonly progress: number;
        readonly achieved: number;
        readonly outcome: number;
      }>;
    } | null;
  }>;
};

export const LoyaltyInfoDocument = gql`
  query LoyaltyInfo {
    currentCustomer {
      id
      __typename
      firstName
    }
    loyaltyProfile {
      customerId
      points {
        total
        available
        pending
      }
      rewards {
        id
        __typename
        name
        expirationDate
        rewardType
        redeemable
        isFeatured
        redeemableAt
        redemptionChannel
        terms
        assetUrl
      }
      pointsRewards {
        id
        __typename
        points
        name: displayName
        redeemable
        assetUrl
      }
      tier {
        id
        __typename
        nameV2
      }
    }
    challenges {
      __typename
      achieved
      celebrationCopy
      descriptiveTitle
      expirationDate
      goal
      id
      legalTerms
      percentageCompleted
      permalink
      progressType
      progress
      progressCopy
      status
      title
      themeV2
      assetUrl
      multipleBehaviorDetails {
        ... on HurdleBehaviorDetails {
          hurdleBehaviors {
            goal
            progress
            achieved
            outcome
          }
        }
      }
    }
  }
`;

export function useLoyaltyInfoQuery(
  options?: Omit<Urql.UseQueryArgs<LoyaltyInfoQueryVariables>, 'query'>,
) {
  return Urql.useQuery<LoyaltyInfoQuery, LoyaltyInfoQueryVariables>({
    query: LoyaltyInfoDocument,
    ...options,
  });
}
